module.exports = __webpack_public_path__ + "img/schedule.a2a1a8a.svg";